import {
	Column,
	Entity,
	Index,
	JoinColumn,
	ManyToOne,
	OneToMany,
} from 'typeorm';
import { BaseEntity } from './base.entity';
import { QueryStoreEntity } from './query-store.entity';
import { ReportTagEntity } from './report-tag.entity';

@Index('_fk__query_store__id', ['fkQueryStoreId'], {})
@Entity('_report')
export class ReportEntity extends BaseEntity {
	@Column('varchar', { name: '_name', length: 255 })
	public name!: string;

	@Column('text', { name: '_description', nullable: true })
	public description!: string | null;

	@Column('int', { name: '_fk__query_store__id', unsigned: true })
	public fkQueryStoreId!: number;

	@Column('varchar', { name: '_resultViewType', length: 32 })
	public resultViewType!: string;

	@Column('longtext', { name: '_config', nullable: true })
	public config!: string | null;

	@ManyToOne(() => QueryStoreEntity, (queryStore) => queryStore.reports, {
		onDelete: 'NO ACTION',
		onUpdate: 'NO ACTION',
	})
	@JoinColumn([{ name: '_fk__query_store__id', referencedColumnName: 'id' }])
	public fkQueryStore!: QueryStoreEntity;

	@OneToMany(() => ReportTagEntity, (reportTag) => reportTag.fkReport, {})
	public reportTags!: Array<ReportTagEntity>;
}
